// SPDX-License-Identifier: AGPL-3.0-or-later

import RuntimeConfig from '@app/features/app/state/RuntimeConfig';
import {LimitResolver} from '@app/features/app/utils/LimitResolverAdapter';
import GuildBoosts from '@app/features/boost/state/GuildBoosts';
import {boostPurchaseState} from '@app/features/boost/utils/GuildBoostPurchase';
import PremiumState from '@app/features/premium/state/PremiumState';
import ShopCatalog from '@app/features/shop/state/ShopCatalog';
import Users from '@app/features/user/state/Users';
import {DEFAULT_FREE_LIMITS} from '@fluxer/limits/src/LimitDefaults';
import {useEffect} from 'react';

// Whether the boost page offers boost:30, read in an observer's render. The catalog is the session's cached one (one
// read per five minutes), and the slots are the page's own list.
export function useGuildBoostPurchase() {
	const shopRuns = RuntimeConfig.giftCodesEnabled;
	useEffect(() => {
		if (shopRuns) void ShopCatalog.load();
	}, [shopRuns]);
	const boost = ShopCatalog.boost;
	const limit = LimitResolver.resolve({
		key: 'max_purchased_boost_slots',
		fallback: DEFAULT_FREE_LIMITS.max_purchased_boost_slots,
	});
	const state = boostPurchaseState({
		shopRuns,
		onSale: boost !== null,
		salesOpen: ShopCatalog.settings?.premium_sales_open === true,
		provider: ShopCatalog.payment?.provider ?? null,
		purchaseDisabled: PremiumState.purchaseDisabledFor(Users.currentUser?.id),
		slots: GuildBoosts.slots,
		limit,
		now: Date.now(),
	});
	return {state, boost, limit};
}
